var _defs, _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderPlacedActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_969",
    width: 44.319,
    height: 44.319,
    viewBox: "0 0 44.319 44.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill:none;stroke:#fff}\r\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    cx: 22.16,
    cy: 22.16,
    r: 22.16,
    fill: "#00ff6f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    d: "M5360.5-11993.007l3.416 3.52 7.868-7.763",
    className: "cls-2",
    transform: "translate(-5341.765 12015.152)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    d: "M5371.744-11997.25l-4.244 4.45",
    className: "cls-2",
    transform: "translate(-5345.901 12015.152)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    d: "M5352.75-11984.752l3.209 3.211 1.138-1.139",
    className: "cls-2",
    transform: "translate(-5337.877 12007.418)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPlacedActive);
export default __webpack_public_path__ + "static/media/order-placed-active.efccfcf0255d1e17cc07bb3f9bee4f54.svg";
export { ForwardRef as ReactComponent };